module.exports = __webpack_public_path__ + "assets/htu-13.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/HTU-modal/htu-13.jpg
// module id = 1200
// module chunks = 7